module.exports = "<ng-container>\n  <h1>{{title}}</h1>\n</ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/pagetitle/pagetitle.component.html
// module id = 694
// module chunks = 2